module.exports = __webpack_public_path__ + "media/images/header-logo-cd0b2e8205e7388d19d4d1d42de7a828.webp";